/* eslint-disable no-unused-vars */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store/index';
import Toast from 'vue-toastification';

import 'vue-toastification/dist/index.css'; // Import the CSS or use your own!
import VueSlideoutPanel from 'vue2-slideout-panel';

import 'vue-easytable/libs/theme-default/index.css'; // import style
import VueEasytable from 'vue-easytable'; // import library

const toastAlertOptions = {
  // You can set your default options here
  position: 'top-center',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false,
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
};

Vue.config.productionTip = false;

Vue.use(Toast, toastAlertOptions);
Vue.use(VueSlideoutPanel);
Vue.use(VueEasytable);


new Vue({
  router,
  store: store,
  render: (h) => h(App),
}).$mount('#app');
